/** The different endpoint actions available for the Committee route. */
export enum CommitteeActions {
  Bills = 'bills',
  Reports = 'reports',
  Nominations = 'nominations'
}
